import React, { useCallback } from "react";
import { useSlate } from "slate-react";
import { Editor } from "slate";
import { IconButton, Tooltip } from "@mui/material";
import {
  CustomEditor,
  CustomTextKey,
  MarkButtonProps,
} from "./RichTextEditor.types";
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import FormatUnderlinedIcon from "@mui/icons-material/FormatUnderlined";
import StrikethroughSIcon from "@mui/icons-material/StrikethroughS";

export const MarkButton: React.FC<MarkButtonProps> = ({ format }) => {
  const editor = useSlate();

  const isMarkActive = (editor: CustomEditor, format: CustomTextKey) => {
    const marks = Editor.marks(editor);
    return marks ? marks[format] === true : false;
  };

  const toggleMark = (editor: CustomEditor, format: CustomTextKey) => {
    const isActive = isMarkActive(editor, format);

    if (isActive) {
      Editor.removeMark(editor, format);
    } else {
      Editor.addMark(editor, format, true);
    }
  };

  const getButtonIcon = useCallback((title: string) => {
    switch (title) {
      case "bold":
        return <FormatBoldIcon fontSize="small" />;
      case "italic":
        return <FormatItalicIcon fontSize="small" />;
      case "underline":
        return <FormatUnderlinedIcon fontSize="small" />;
      case "strikethrough":
        return <StrikethroughSIcon fontSize="small" />;
    }
  }, []);

  return (
    <Tooltip title={format.charAt(0).toUpperCase() + format.slice(1)}>
      <IconButton
        size="small"
        onMouseDown={(event) => {
          event.preventDefault();
          toggleMark(editor, format);
        }}
        color={isMarkActive(editor, format) ? "primary" : "default"}
      >
        {getButtonIcon(format)}
      </IconButton>
    </Tooltip>
  );
};
